<template>
	<v-row class="mt-4" no-gutters justify="center">
		<v-alert max-width="600px" outlined type="warning" color="red" prominent>
			<p class="text-body-2 mx-sm-4 mx-2">
				<slot name="text">
					この{{ name }}は、<strong>{{ status }}</strong
					>となっています。
					<br />
					{{ actionName }}、または、差し戻しを行ってください。
				</slot>
			</p>
			<v-row class="mt-4" no-gutters justify="space-around">
				<ConfirmationDialog
					v-if="requiredConfirmationDialog"
					:dialog.sync="approvalDialog"
					:confirm_options="confirmationOptions"
					requireBtn
					@accept="$emit('accept')"
				>
					<template v-slot:open-btn-content>
						<v-icon class="mr-1"> mdi-check </v-icon>
						{{ actionName }}する
					</template>
				</ConfirmationDialog>
				<template v-else>
					<v-btn color="secondary" @click="$emit('accept')">
						<v-icon class="mr-1"> mdi-check </v-icon>
						{{ actionName }}する
					</v-btn>
				</template>
				<v-menu v-model="menu" :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="red" dark v-bind="attrs" v-on="on">
							<v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
							差し戻し
						</v-btn>
					</template>

					<v-card width="400px" class="top-border-menu top-border-menu--red">
						<v-form ref="form" v-model="valid" class="pa-2">
							<v-textarea
								class="mt-4"
								v-model="reason"
								label="差し戻し理由"
								:rules="[rules.required]"
								hint="差し戻し理由は依頼者へメッセージとして送信されます。"
								outlined
								required
							/>
						</v-form>
						<v-card-actions class="ma-0">
							<v-row no-gutters justify="space-around">
								<v-btn
									color="red"
									:dark="valid"
									@click="$emit('reject', reason)"
									:disabled="!valid"
								>
									<v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
									差し戻し
								</v-btn>
								<v-btn text @click="menu = false"> キャンセル </v-btn>
							</v-row>
						</v-card-actions>
					</v-card>
				</v-menu>
			</v-row>
		</v-alert>
	</v-row>
</template>

<script>
import rules from "../../helper/rules"

export default {
	name: "ConfirmationSection",
	props: {
		// データの名前
		name: {
			type: String,
			required: true,
		},
		// データの状態
		status: {
			type: String,
			default: "承認待ち",
		},
		// アクション名：承認、確認、など
		actionName: {
			type: String,
			default: "承認",
		},
		// confirmationDialogに渡す
		confirm_options: {
			type: Object,
		},
		// 確認ダイアログに使うかどうか
		requiredConfirmationDialog: {
			type: Boolean,
			default: true,
		},
		// ダブルクリックで確認ダイアログをスキップするかどうか
		skipDialogWithDblClick: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			approvalDialog: false,
			menu: false,
			valid: false,
			reason: "",
			confirmationOptions: {},
			rules,
		}
	},
	mounted() {
		if (!this.confirm_options) {
			this.confirmationOptions = {
				title: this.actionName,
				text: `本当に${this.actionName}してよろしいですか？`,
				confirmBtnText: `${this.actionName}する`,
				cancelBtnText: "キャンセル",
			}
		} else {
			this.confirmationOptions = this.confirm_options
		}
	},
}
</script>

<style>
</style>